import React, { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Container, Dialog, DialogActions, DialogTitle, TextField, Typography } from "@mui/material";

import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { getDoc, doc, serverTimestamp, setDoc } from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function InfoCreate() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [user, setUser] = useState("");

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    const handleCreateClick = async () => {
        let randomId;
        let ruleSnap;
        do {
            randomId = Math.random().toString(36).substring(2, 12);

            const ruleRef = doc(db, "houseRule", randomId);
            ruleSnap = await getDoc(ruleRef);
        } while (ruleSnap.exists());

        try {
            const documentRef = doc(db, "houseRule", randomId);
            await setDoc(documentRef, {
                id: randomId,
                title: title,
                description: description,
                auther: user,
                createAt: serverTimestamp(),
                updateAt: serverTimestamp(),
            });
        } catch (error) {
            console.error("error: ", error);
        }

        setSaveOpen(true);
    };

    const [saveOpen, setSaveOpen] = useState(false);
    const handleSaved = () => {
        window.scrollTo(0, 0);
        navigate("/house-rule", { replace: true });
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged((userLogin) => {
            if (userLogin) {
                const uid = userLogin.uid;
                setUser(uid);
                setLoading(false);
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>HouseRule Create - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                <Container>
                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ mt: 10 }}
                    >
                        <Typography variant="h6">ハウスルール作成</Typography>
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ m: 3 }}
                    >
                        <TextField
                            variant="filled"
                            label="タイトル"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            sx={{ minWidth: 350 }}
                        />
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ m: 3 }}
                    >
                        <TextField
                            variant="filled"
                            label="内容"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            multiline
                            rows={10}
                            sx={{ minWidth: 350 }}
                        />
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ mt: 5, mb: 2 }}
                    >
                        <Button variant="contained" onClick={handleCreateClick} size="large" sx={{ width: "350px" }}>
                            作成
                        </Button>
                    </Box>
                </Container>
            </Container>

            <Dialog open={saveOpen}>
                <DialogTitle
                    sx={{
                        minWidth: 263,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    作成しました
                </DialogTitle>
                <DialogActions sx={{ justifyContent: "center", display: "flex", mb: 2 }}>
                    <Button variant="contained" sx={{ width: "100px" }} onClick={handleSaved}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default InfoCreate;
